import React, { useState, useEffect } from "react";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import {
  GetQuestionParentEdit,
  GetQuestionTypeList,
  UpdateQuestionParentData,
} from "../../services/QuestionsService";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { Trans, useTranslation } from "react-i18next";

function EditQuestionParent() {
  const { t } = useTranslation();
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [statusData, setStatusData] = useState([
    { label: t(`mcq_manager.Active`), value: "1", id: 1 },
    { label: t(`mcq_manager.Inactive`), value: "0", id: 0 },
  ]);
  const [lang_id, setLangId] = useState(() => {
    // Retrieve the lang_id from localStorage or set it to "1" if it doesn't exist or equals 1
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });

  const [questionType, setQuestionType] = useState([]);
  const { id } = useParams();

  const history = useHistory();

  useEffect(() => {
    GetQuestionParentEdit(id, lang_id)
      .then(res => {
        if (res?.status === 200) {
          setFormDataValues(res?.data?.data);
        }
      })
      .catch(err => {
        setErrors({ message: "No data available", error: err });
      });
  }, [id]);

  useEffect(() => {
    GetQuestionTypeList(lang_id)
      .then(res => {
        if (res?.status === 200) {
          let qt = res?.data?.data
            ?.map(item => {
              if (item?.slug === "caselet") {
                return {
                  label: item?.ques_type,
                  value: item?.id,
                  id: item?.id,
                  slug: item?.slug,
                };
              }
              return null; // Returning null for items that don't match the condition
            })
            .filter(item => item !== null); // Filtering out null items
          setQuestionType(qt);
        }
      })
      .catch(err => {
        console.error("Error fetching department list:", err);
      });
  }, []);

  /* State Field selected value */

  const handleChangeQuestionTypeValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      ques_type_id: e?.value,
    }));
  };
  const handleQuestionTypeValuePopulate = id => {
    if (questionType) {
      let qt = questionType?.filter(items => items?.id === id);
      return qt;
    } else {
      return null;
    }
  };
  const handleChangeStatusValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };
  const handleStatusValuePopulate = id => {
    if (statusData) {
      let st = statusData?.find(items => items?.id == id);
      return st;
    } else {
      return null;
    }
  };

  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  // Validation logic for each field
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formDataValues.ques_parent) {
      newErrors.ques_parent = t(`mcq_manager.QuestionParentRequired`);
      isValid = false;
    }
    if (!formDataValues.ques_parent_desc) {
      newErrors.ques_parent_desc = t(
        `mcq_manager.QuestionParentDescriptionRequired`
      );
      isValid = false;
    }
    if (!formDataValues.ques_type_id) {
      newErrors.ques_type_id = t(`mcq_manager.QuestionTypeRequired`);
      isValid = false;
    }
    if (![0, 1].includes(parseInt(formDataValues.status))) {
      newErrors.status = t(`mcq_manager.PleaseSelectAnOption`);
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Submit the form data or perform other actions
  const handleSubmit = async e => {
    if (validateForm()) {
      let formData = new FormData();
      formData.append("ques_parent", e?.ques_parent);
      formData.append("ques_parent_desc", e?.ques_parent_desc);
      formData.append("ques_type_id", e?.ques_type_id);
      formData.append("status", e?.status);
      let fromEntriesObj = Object.fromEntries(formData);
      UpdateQuestionParentData(fromEntriesObj, id, lang_id)
        .then(res => {
          if (res?.status === 200) {
            toast.success(res?.data?.message);
            window.location.href = "/question-parent-list";
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          console.error("Error creating question parent:", err);
          setErrors("No data created.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  if (!checkPermissionStatus("question-parent-list", "edit")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center border-bottom py-2 pt-0">
            <Col lg="6" md="6">
              <Link to="/question-parent-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`mcq_manager.Edit Question Parent`)}
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/question-parent-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Container fluid>
              {/* <Breadcrumbs title="Question Parent" breadcrumbItem="Edit Question Parent" /> */}
              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}

                      <Row>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_parent"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Question Parent`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div title={t(`mcq_manager.Question Parent`)}>
                              <AvField
                                type="text"
                                className="form-control"
                                id="ques_parent"
                                name="ques_parent"
                                placeholder={t(`mcq_manager.Question Parent`)}
                                errorMessage={t(
                                  `mcq_manager.QuestionTypeRequired`
                                )}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t(
                                      `mcq_manager.QuestionParentRequired`
                                    ),
                                  },
                                  minLength: {
                                    value: 2,
                                    errorMessage: t(
                                      `mcq_manager.Question Parent must be at least 2 characters`
                                    ),
                                  },
                                }}
                                value={formDataValues?.ques_parent || ""}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="error">{errors.ques_parent}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_type_id"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Question Type`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={
                                formDataValues.ques_type_id
                                  ? `${
                                      questionType.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.ques_type_id
                                      )?.label
                                    }`
                                  : `${t("mcq_manager.Question Type")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(
                                  `mcq_manager.Select Question Type`
                                )}
                                id="ques_type_id"
                                name="ques_type_id"
                                validate={{ required: { value: true } }}
                                options={questionType}
                                onChange={e =>
                                  handleChangeQuestionTypeValuePopulate(e)
                                }
                                value={handleQuestionTypeValuePopulate(
                                  formDataValues?.ques_type_id || ""
                                )}
                                aria-label={t(`mcq_manager.Question Type`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.ques_type_id}</div>
                          </FormGroup>
                        </Col>

                        {/* <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_parent"
                              className="col-form-label"
                            >
                              Question Parent
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="ques_parent"
                              name="ques_parent"
                              placeholder="Question Parent"
                              errorMessage="Question Type Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Question Parent is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Question Parent must be at least 2 characters",
                                },
                              }}
                              value={formDataValues?.ques_parent || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.ques_parent}</div>
                          </FormGroup>
                        </Col> */}

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label className="col-form-label">
                              {t(`mcq_manager.Status`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={
                                formDataValues.status
                                  ? `${
                                      statusData.find(
                                        elem =>
                                          elem.value == formDataValues.status
                                      )?.label
                                    }`
                                  : `${t("mcq_manager.Status")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(`mcq_manager.Status`)}
                                id="status_id"
                                name="status"
                                validate={{ required: { value: true } }}
                                options={statusData}
                                onChange={e =>
                                  handleChangeStatusValuePopulate(e)
                                }
                                value={handleStatusValuePopulate(
                                  formDataValues?.status || ""
                                )}
                                aria-label={t(`mcq_manager.Status`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.status}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="12">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_parent_desc"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Question Parent Description`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={t(
                                `mcq_manager.Question Parent Description`
                              )}
                            >
                              <AvField
                                type="text"
                                className="form-control"
                                id="ques_parent_desc"
                                name="ques_parent_desc"
                                placeholder={t(
                                  `mcq_manager.Question Parent Description`
                                )}
                                value={formDataValues?.ques_parent_desc || ""}
                                onChange={handleChange}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t(
                                      `mcq_manager.QuestionParentDescriptionRequired`
                                    ),
                                  },
                                  minLength: {
                                    value: 2,
                                    errorMessage: t(
                                      "mcq_manager.questionParentChar"
                                    ),
                                  },
                                }}
                              />
                            </div>
                            <div className="error">
                              {errors.ques_parent_desc}
                            </div>
                          </FormGroup>
                        </Col>

                        <div className="cta text-center d-flex justify-content-left gap-3 mt-4 mb-4">
                          <Button
                            type="button"
                            className="btn btn-secondary"
                            onClick={e => {
                              e.preventDefault();
                              history.push("/question-parent-list");
                            }}
                          >
                            {" "}
                            {t(`mcq_manager.Cancel`)}
                          </Button>
                          &nbsp;
                          <Button
                            type="submit"
                            color="success"
                            className="btn btn-primary"
                          >
                            {t(`mcq_manager.Update`)}
                          </Button>
                        </div>
                      </Row>
                    </div>
                  </div>
                </AvForm>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default EditQuestionParent;
